import axios, { AxiosError } from 'axios';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_WATCH_LIST } from '@/constants';
import { toast } from 'react-toastify';
import { setWatchlistStatus, rollbackWatchlistStatus } from './watchlistCache';

export const useDeleteFromWatchList = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation<unknown, AxiosError, { id: string }>({
    onMutate: async ({ id }) => {
      const rollback = setWatchlistStatus(queryClient, id, false);
      return { id, rollback };
    },
    onError: (error, _vars, context) => {
      const ctx = context as
        | { id: string; rollback: ReturnType<typeof setWatchlistStatus> }
        | undefined;
      if (ctx) {
        rollbackWatchlistStatus(queryClient, ctx.id, ctx.rollback);
      }
      toast.error(error.message);
      console.error(error);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['watchList'] });
      onSuccess?.();
    },
    mutationFn: ({ id }) => axios.delete(`${GET_WATCH_LIST}/${id}`).then((res) => res.data),
  });
};
